export default __webpack_public_path__ + "static/media/BUJO-BG1.d4372dd0.png";